export default __webpack_public_path__ + "static/media/footer-bg.6cf85ad1.jpg";